import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getMarketing } from "stores";
import { getKunjunganAllMarketing } from "stores";
import ReactPaginate from "react-paginate";

const ListKunjunganMarketing = (data) => {
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const auth = useSelector((state) => state.authReducer);
  const [isLoading, setIsLoading] = React.useState(true);
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [listKunjunganMarketing, setListKunjunganMarketing] = React.useState(
    [],
  );
  const [searchText, setSearchText] = React.useState("");
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleFilterChange = () => {
    setIsLoading(true);
    setPage(0);
    getKunjunganAllMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleClick = () => {
    dispatch({ type: "SET_DETAIL_KUNJUNGAN", data: true });
  };

  React.useEffect(() => {
    let tmp =
      data.data &&
      data.data.map((val) => {
        return {
          ...val,
          action: (
            <>
              {/* {" "}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: "#F75D59",
                    border: 0,
                  }}
                  onClick={() => {
                    handleDetailsClick(val);
                  }}
                >
                  <i class="fas fa-info"></i>
                </Button>
              </OverlayTrigger>{" "} */}
            </>
          ),
        };
      });
    setListKunjunganMarketing(tmp);
  }, [data.data]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const getTypeKunjungan = (status) => {
    switch (status) {
      case "Dinas":
        return {
          fontWeight: "bold",
          backgroundColor: "#DDF3F4",
          textColor: "#0C8990",
        };
      case "Personal":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFF6E6",
          textColor: "#FFA700",
        };
      default:
        return {};
    }
  };

  const getHasil = (hasilNasabah) => {
    switch (hasilNasabah) {
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Pinjam":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      case "-":
        return {
          fontWeight: "bold",

          textColor: "#000000",
        };
      default:
        return {};
    }
  };

  const getKeputusan = (keputusan) => {
    switch (keputusan) {
      case "Tunda":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6CC",
          textColor: "#FF7F00",
        };
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E4F5C9",
          textColor: "#87CB16",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF0000",
          textColor: "#FFE6E6",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F1F5F9",
        minHeight: "50px",
        borderTop: "1px solid #E2E8F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "11px",
        color: "#475569",
        textTransform: "uppercase",
        justifyContent: "center",
      },
    },
    rows: {
      style: {
        minHeight: "75px", // Sedikit lebih tinggi untuk menampung teks tumpuk
        "&:hover": {
          backgroundColor: "#F8FAFC",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "13px",
        color: "#1E293B",
        justifyContent: "center",
      },
    },
  };

  const colKunjungan = [
    {
      name: "NO",
      width: "60px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      style: { fontWeight: "bold", color: "#94A3B8" },
    },
    {
      name: "IDENTITAS NASABAH",
      minWidth: "250px",
      cell: (row) => (
        <div className="py-2 text-left w-100 pl-2">
          <div className="fw-800 text-dark" style={{ fontSize: "13px" }}>
            {row.calonNasabah?.namaNasabah || "-"}
          </div>
          <div
            className="d-flex flex-column mt-1"
            style={{ gap: "2px", fontSize: "13px" }}
          >
            <span className="text-muted">
              <i className="far fa-id-card mr-1"></i> {row.calonNasabah?.nik}
            </span>
            <span className="text-primary fw-600">
              <i className="fas fa-phone-alt mr-1"></i> {row.calonNasabah?.noHp}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "WAKTU KUNJUNGAN",
      minWidth: "200px",
      cell: (row) => (
        <div className="text-center">
          <div className="fw-700">
            {moment(row.tglKunjungan).format("DD MMM YYYY")}
          </div>
          <div className="text-muted small" style={{ fontSize: "13px" }}>
            Lahir: {moment(row.calonNasabah?.tglLahir).format("DD/MM/YYYY")}
          </div>
        </div>
      ),
    },
    {
      name: "TIPE & HASIL",
      minWidth: "200px",
      cell: (row) => {
        const typeStyle = getTypeKunjungan(row.calonNasabah?.typeKunjungan);
        const hasilStyle = getHasil(row.hasil || "-");
        return (
          <div className="d-flex flex-column w-100 px-3" style={{ gap: "4px" }}>
            <span
              style={{
                backgroundColor: typeStyle.backgroundColor,
                color: typeStyle.textColor,
                fontSize: "13px",
                fontWeight: "800",
                padding: "4px",
                borderRadius: "4px",
                textAlign: "center",
              }}
            >
              {row.calonNasabah?.typeKunjungan}
            </span>
            <span
              style={{
                backgroundColor: hasilStyle.backgroundColor,
                color: hasilStyle.textColor,
                fontSize: "13px",
                fontWeight: "800",
                padding: "4px",
                borderRadius: "4px",
                textAlign: "center",
              }}
            >
              {row.hasil || "-"}
            </span>
          </div>
        );
      },
    },
    {
      name: "FINANSIAL (PLAFOND/NETT)",
      minWidth: "250px",
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center w-100 py-2">
          <div className="text-right pr-3 border-right" style={{ flex: 1 }}>
            <div
              className="text-muted"
              style={{ fontSize: "12px", fontWeight: "800" }}
            >
              PLAFOND
            </div>
            <div className="fw-700 text-dark" style={{ fontSize: "13px" }}>
              {new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
              }).format(row.plafond)}
            </div>
          </div>
          <div className="text-left pl-3" style={{ flex: 1 }}>
            <div
              className="text-muted"
              style={{ fontSize: "12px", fontWeight: "800" }}
            >
              NETT
            </div>
            <div className="fw-800 text-success" style={{ fontSize: "13px" }}>
              {new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
              }).format(row.nett)}
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "KEPUTUSAN",
      minWidth: "150px",
      center: true,
      cell: (row) => {
        const statusStyle = getKeputusan(row.keputusan);
        return (
          <span
            style={{
              fontWeight: "800",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "13px",
              border: `1px solid ${statusStyle.textColor}20`,
            }}
          >
            {row.keputusan || "-"}
          </span>
        );
      },
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getKunjunganAllMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      cari: "",
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [tglAwal, tglAkhir, page, totalPerHalaman]);
  return (
    <>
      <Container fluid className="py-4">
        {/* BACK BUTTON: Soft UI Style */}
        <Button
          className="btn-icon shadow-sm mb-4 d-flex align-items-center justify-content-center"
          style={{
            width: "42px",
            height: "42px",
            borderRadius: "12px",
            backgroundColor: "#fff",
            border: "1px solid #e2e8f0",
            color: "#F75D59",
          }}
          onClick={handleClick}
        >
          <i className="fas fa-arrow-left"></i>
        </Button>

        <Row>
          <Col md="12">
            <Card className="border-0 shadow-sm rounded-xl">
              <Card.Header className="bg-white border-0 pt-4 px-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3
                      className="fw-800 text-dark m-0"
                      style={{ letterSpacing: "1px" }}
                    >
                      DETAIL KUNJUNGAN MARKETING
                    </h3>
                    <p className="text-muted small mb-0">
                      Laporan rincian performa dan riwayat kunjungan harian.
                    </p>
                  </div>
                  {/* Info Badge */}
                  <div className="bg-light px-3 py-2 rounded-pill border d-none d-md-block">
                    <span className="text-muted fw-bold small">
                      <i className="fas fa-info-circle mr-2 text-danger"></i>
                      Informasi Terperinci
                    </span>
                  </div>
                </div>
                <hr className="mt-3" />
              </Card.Header>

              <Card.Body className="px-4 pb-4">
                {isLoading ? (
                  <div className="py-5 text-center d-flex flex-column align-items-center">
                    <Watch height="70" width="70" color="#F75D59" />
                    <h5 className="mt-4 fw-600 text-muted animate-pulse">
                      Menyiapkan Laporan Detail...
                    </h5>
                  </div>
                ) : listKunjunganMarketing.length > 0 ? (
                  <div className="table-responsive-custom">
                    <DataTable
                      columns={colKunjungan}
                      data={listKunjunganMarketing}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={itemsPerPage}
                      onChangePage={handlePageChange}
                      highlightOnHover
                      pointerOnHover
                    />
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <img
                      src={require("assets/img/sorry.jpg").default}
                      alt="Empty"
                      style={{ maxWidth: "180px", opacity: "0.8" }}
                    />
                    <h5 className="mt-4 fw-800 text-muted">
                      Belum ada data kunjungan untuk marketing ini.
                    </h5>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <style>{`
    .fw-800 { font-weight: 800; }
    .rounded-xl { border-radius: 20px !important; }
    .animate-pulse { animation: pulse 2s infinite; }
    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }

    /* Memperbaiki style pagination agar lebih stylish */
    .rdt_Pagination {
      border-top: 1px solid #f1f5f9 !important;
      padding: 15px 0 !important;
    }

    /* Table Container Styling */
    .rdt_Table { border: 1px solid #f1f5f9; border-radius: 15px; }
  `}</style>
      </Container>
    </>
  );
};

export default ListKunjunganMarketing;
